const MODEL_NAMES = {
  "XLSRO-250-SD": "FG-RO-0.25T-A",
  "XLSRO-500-S": "FG-RO-0.5T-A",
  "XLSRO-1000-S": "FG-RO-1T-A"
};

export function formatDeviceModel(deviceType) {
  return MODEL_NAMES[deviceType] || "--";
}

export function formatProtocolTime(value) {
  if (value === undefined || value === null || value === "") {
    return "--";
  }

  const timestamp = typeof value === "string" ? parseInt(value, 10) : value;
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) {
    return "--";
  }

  const pad = number => String(number).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}`;
}

export function parseDeviceInfo(protocol) {
  const source = protocol || {};
  const deviceType = source.deviceType || "--";

  return {
    id: source.id || "117",
    deviceType,
    modelName: formatDeviceModel(deviceType),
    status: source.status || "--",
    seriesNumber: source.seriesNumber || "--",
    updateTime: formatProtocolTime(source.updateTime)
  };
}
